<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-toolbar class="mb-2 pa-0" color="primary" dark flat>
          <v-toolbar-title>{{ grafTitle }}</v-toolbar-title>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-row align="center">
      <v-col cols="2">
        <v-autocomplete
          label="Lokalita"
          v-model="filterLokalitaId"
          :items="lokality"
          item-text="Name"
          item-value="ID"
          clearable
        >
        </v-autocomplete>
      </v-col>
      <v-col cols="2">
        <v-autocomplete
          label="Bod"
          v-model="filterBodId"
          :items="body"
          item-text="ZNMB"
          item-value="ID"
          ref="acBod"
          clearable
        >
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title>
                {{ item.ZNMB }} - {{ item.IDMB }}
              </v-list-item-title>
              <v-list-item-subtitle>
                <b>Dátum od:</b> {{ item.DatumOdString }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                <b>Dátum do:</b> {{ item.DatumDoString }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row v-if="grafData1.length > 0">
      <v-col cols="12">
        <line-chart
          :chart-data="grafValues(1)"
          :options="grafOptions(1)"
        ></line-chart>
      </v-col>
    </v-row>
    <v-row v-if="grafData2.length > 0">
      <v-col cols="12">
        <line-chart
          :chart-data="grafValues(2)"
          :options="grafOptions(2)"
        ></line-chart>
      </v-col>
    </v-row>
  </div>
</template>

<script>
//import * as moment from "moment"
import * as Miscella from "../plugins/miscella.js"
import * as Colors from "../plugins/colors.js"
import LineChart from "../components/charts/LineChart.js"

export default {
  data: function () {
    return {
      loading: false,
      filterLokalitaId: "",
      filterBodId: "",
      grafData1: [],
      grafData2: [],
      lokality: [],
      body: [],
    }
  },
  components: { LineChart },
  props: {},
  computed: {
    grafTitle: function () {
      return "Grafy - Mikromorfologické zmeny"
    },
  },
  watch: {
    filterLokalitaId: {
      immediate: true,
      handler: function () {
        this.filterBodId = ""
        this.readBody()
      },
    },
    filterBodId: {
      immediate: true,
      handler: function () {
        console.log(
          "filterBodId:" + Miscella.normalizeString(this.filterBodId) + ";"
        )
        if (Miscella.normalizeString(this.filterBodId) !== "") {
          this.show()
        }
      },
    },
  },
  methods: {
    readLokality: async function () {
      try {
        this.lokality = []
        let response = await this.$axios.get("/r/lokality/mer_mikroniv")
        if (response.status === 200) {
          this.lokality = response.data
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },
    readBody: async function () {
      try {
        this.body = []
        if (
          Miscella.isSet(this.filterLokalitaId) &&
          this.filterLokalitaId !== ""
        ) {
          let response = await this.$axios.get(
            "/r/body/" + this.filterLokalitaId + "/mer_mikroniv"
          )
          if (response.status === 200) {
            let body = response.data
            for (let i = 0; i < body.length; i++) {
              let bod = body[i]
              bod.DatumOd = Miscella.zeroDatum(bod.DatumOd)
              bod.DatumDo = Miscella.zeroDatum(bod.DatumDo)
              bod.DatumOdString = Miscella.formatDatum(bod.DatumOd)
              bod.DatumDoString = Miscella.formatDatum(bod.DatumDo)
            }
            this.body = body
          } else {
            this.$store.commit("alert", response.data.Error)
          }
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },
    grafValues: function (aIndex) {
      let ret = ""
      if (aIndex === 1) {
        let colors = Colors.defaultColors()
        console.log("colors", colors)
        let colorIndex = 0
        let datasets = []
        this.grafData1.forEach((item) => {
          let dataset = {}
          dataset = {
            label: item.Obdobie,
            type: "line",
            backgroundColor: colors[colorIndex],
            borderColor: colors[colorIndex],
            pointRadius: "0",
            borderWidth: "1",
            lineTension: 0,
            pointStyle: "line",
            fill: false,
            data: item.Hodnoty,
          }
          colorIndex++
          datasets.push(dataset)
        })
        ret = {
          labels: [1, 2, 3, 4, 5, 6, 7, 8],
          datasets: datasets,
        }
      }
      if (aIndex === 2) {
        ret = {
          labels: [1, 2, 3, 4, 5, 6, 7, 8],
          datasets: [
            {
              label: "Suma",
              type: "line",
              backgroundColor: "#0000ff",
              borderColor: "#0000ff",
              pointRadius: "0",
              borderWidth: "1",
              lineTension: 0,
              pointStyle: "line",
              fill: false,
              data: this.grafData2,
            },
          ],
        }
      }
      return ret
    },
    grafOptions: function (aIndex) {
      let ret = ""
      ret = {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          //display: false
        },
        title: {
          display: true,
          text:
            aIndex === 1
              ? "Mikromorfologické zmeny"
              : "Suma Mikromorfologických zmien povrchu horniny",
        },
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "[mm]",
              },
            },
          ],
        },
      }
      return ret
    },
    urlFetch: function () {
      let url = "/r/chart/mikroniv?"
      url += "bodID=" + Miscella.normalizeString(this.filterBodId)
      return url
    },
    show: async function () {
      this.grafData1 = []
      this.grafData2 = []
      try {
        console.log("show")
        this.loading = true
        let response = await this.$axios.get(this.urlFetch())
        if (response.status === 200) {
          this.grafData1 = response.data.data
          this.grafData2 = response.data.suma
          if (this.grafData1 === null) {
            this.grafData1 = []
          }
          if (this.grafData2 === null) {
            this.grafData2 = []
          }
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      } finally {
        this.loading = false
      }
    },
  },
  mounted: async function () {
    await this.$store.dispatch("fetchme", this.$axios)
    this.readLokality()
  },
}
</script>
